import { InjectionToken } from '@angular/core';

export interface Refreshable {
  refreshData(): void | Promise<void>;
}

export const REFRESHABLE = new InjectionToken<Refreshable>(
  'Refreshable instance',
);

export function isRefreshable(obj: any): obj is Refreshable {
  return obj && typeof obj.refreshData === 'function';
}
